import { updateObject } from 'utils/updateObject'
import {
  CLEAR_FILTERS,
  DROP_LIST,
  SET,
  SET_FILTERS,
  SET_LOADING,
} from 'modules/Recommendations/CampaignsRecommendations/Type/types'
import setFiltersUtil from 'store/reducer-utils/setFilters'

const initialState = {
  loading: true,
  data: [],
  filters: null,
  sorting: [
    {
      id: 'campaign_id',
      desc: false,
    },
  ],
  pagination: {
    limit: 50,
    total: 0,
  },
}

const setData = (state, { payload }) =>
  updateObject(state, {
    ...payload,
    data: [...state.data].concat(payload.data),
    loading: false,
    pagination: {
      ...state.pagination,
      ...payload.pagination,
    },
  })

const setLoading = (state, { payload }) => updateObject(state, payload)

const dropList = (state) =>
  updateObject(state, {
    data: [],
    pagination: { ...initialState.pagination },
  })

const setFilters = (state, action) => {
  const filteredPayload = state?.filters
    ? [...action.payload].filter(
        (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
      )
    : action.payload

  return setFiltersUtil(state, { ...action, payload: filteredPayload })
}

const clearFilters = (state) => {
  return updateObject(state, {
    filters: null,
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADING:
      return setLoading(state, action)
    case SET:
      return setData(state, action)
    case DROP_LIST:
      return dropList(state, action)
    case SET_FILTERS:
      return setFilters(state, action)
    case CLEAR_FILTERS:
      return clearFilters(state, action)

    default:
      return state
  }
}

export default reducer
